import type { ReactElement, ReactNode } from "react";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import websiteOgImageJPEG from "assets-new/img/website-og-image.jpg";
import { useAbsoluteUrl, useFacebookAppId } from "contexts";

type SeoHelmetProps = {
	title: string;
	description?: string;
	children?: ReactNode;
};

export default function SeoHelmet({
	title,
	description,
	children,
}: SeoHelmetProps): ReactElement {
	const { pathname } = useLocation();
	const websiteOgImageSrc = useAbsoluteUrl(websiteOgImageJPEG);
	const rootUrl = useAbsoluteUrl(pathname);
	const fbAppId = useFacebookAppId();

	// TODO: Can do for logged in:
	// userId="1234"
	// attributes={{ email: "user@example.com", company: "Acme Inc" }}

	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description || title} />
			<meta property="og:type" content="website" />
			<meta property="og:title" content={title || "Brick Me"} />
			<meta property="og:description" content={description || title} />
			<meta property="og:url" content={rootUrl} />
			<meta property="og:site_name" content="Brick Me" />
			<meta property="og:image" content={websiteOgImageSrc} />
			{fbAppId && <meta property="fb:app_id" content={fbAppId} />}
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:description" content={description || title} />
			<meta name="twitter:title" content={title || "Brick Me"} />
			<meta property="twitter:image" content={websiteOgImageSrc} />
			<link rel="canonical" href={rootUrl} />
			{children}
		</Helmet>
	);
}
